import { Navigate } from "react-router-dom";
import { isAdminAuthenticated } from "@/lib/adminAuth";

/**
 * Route guard for admin-only pages.
 * Redirects to /admin/login if there's no valid token in localStorage.
 */
const RequireAdmin = ({ children }) => {
  if (!isAdminAuthenticated()) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};

export default RequireAdmin;
